
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Curriculumleft from './Curriculumleft';

const BtechMSDualdegree_curriculumEle = () => {
    const curriculumData = [
        {
            department: 'Computer Science and Engineering',
            specializations: [
                {
                    name: 'B.Tech + M.S.(R) in Computer Science and Engineering',
                    curricula: [
                        {
                            batch: '2022 Batch Onwards',
                            url: 'https://files.iittp.ac.in/pdfs/curriculum/dualdegree/2025/B.Tech_M.S_CSE_2025_Curriculum.pdf',
                        },
                    ],
                },
            ],
        },
    ];

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col
                        md={4}
                        className="c-left custom-padding-color mb-4"
                    >
                        <Curriculumleft activeIndex={5} />
                    </Col>

                    <Col md={8} className="c-right mt-2 ps-5">
                        <h3 className="text-center mb-5">
                            Dual Degree (B.Tech + M.S.(R)) Curriculum
                        </h3>

                        <h5>
                            Curriculum for the Dual Degree B.Tech + M.S.(R)
                            Programme is listed below:
                        </h5>

                        <table className="table table-bordered table-hover align-middle mt-4">
                            <thead className="table-primary text-center">
                                <tr>
                                    <th width="10%">S.No.</th>
                                    <th width="35%">Department</th>
                                    <th width="35%">Programme</th>
                                    <th width="20%">Batch</th>
                                </tr>
                            </thead>

                            <tbody>
                                {curriculumData.map((dept, deptIndex) => {
                                    const departmentRowSpan =
                                        dept.specializations.reduce(
                                            (total, spec) =>
                                                total + spec.curricula.length,
                                            0
                                        );

                                    return dept.specializations.flatMap(
                                        (spec, specIndex) =>
                                            spec.curricula.map(
                                                (item, itemIndex) => (
                                                    <tr
                                                        key={`${deptIndex}-${specIndex}-${itemIndex}`}
                                                        className={
                                                            deptIndex % 2 === 0
                                                                ? 'table-light'
                                                                : 'table-secondary'
                                                        }
                                                    >
                                                        {specIndex === 0 &&
                                                            itemIndex === 0 && (
                                                                <>
                                                                    <td
                                                                        rowSpan={departmentRowSpan}
                                                                        className="text-center align-middle fw-bold"
                                                                    >
                                                                        {deptIndex + 1}
                                                                    </td>

                                                                    <td
                                                                        rowSpan={departmentRowSpan}
                                                                        className="align-middle fw-bold"
                                                                    >
                                                                        {dept.department}
                                                                    </td>
                                                                </>
                                                            )}

                                                        {itemIndex === 0 && (
                                                            <td
                                                                rowSpan={spec.curricula.length}
                                                                className="align-middle"
                                                            >
                                                                {spec.name}
                                                            </td>
                                                        )}

                                                        <td>
                                                            <Link
                                                                to={item.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-decoration-none"
                                                            >
                                                                <i className="fas fa-file-pdf text-danger me-2"></i>
                                                                {item.batch}
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                    );
                                })}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default BtechMSDualdegree_curriculumEle;
